import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const company = {
  fetchCompanies: lazyModuleMethod(() => import('./fetchCompanies'), 'default'),
  createCompany: lazyModuleMethod(() => import('./createCompany'), 'default'),
  deleteCompany: lazyModuleMethod(() => import('./deleteCompany'), 'default'),
  fetchCompany: lazyModuleMethod(() => import('./fetchCompany'), 'default'),
  updateCompany: lazyModuleMethod(() => import('./updateCompany'), 'default'),
  addExpertForCompany: lazyModuleMethod(
    () => import('./addExpertForCompany'),
    'default'
  ),
  deleteExpertFromCompany: lazyModuleMethod(
    () => import('./deleteExpertFromCompany'),
    'default'
  ),
  restoreCompany: lazyModuleMethod(() => import('./restoreCompany'), 'default'),
  fetchDeletedCompany: lazyModuleMethod(
    () => import('./fetchDeletedCompany'),
    'default'
  ),
}
